import { makeStyles } from "@mui/styles";

const styles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(1),
  },
}));
export default styles;
